export const cz = {
  title: 'Tiráž',
  subtitle: 'Povinné údaje podle nařízení EU 2018/302 a estonského obchodního zákoníku (äriseadustik) · Stav: 10.05.2026',
  sections: [
    {
      id: 'company',
      title: 'Poskytovatel služeb',
      body:
        '**MATTALNET GRUPP OÜ**\nTuukri tn 19-315\n10120 Tallinn, Estonsko (Estonia)\n\n- **Registrikood (číslo v obchodním rejstříku):** 14744075\n- **DIČ / KMKR number:** EE102519059\n- **EORI:** EE14744075\n- **D-U-N-S:** 536415812\n- **Rejstřík:** Eesti äriregister (Estonský obchodní rejstřík)\n- **Právní forma:** Osaühing (OÜ) — společnost s ručením omezeným podle estonského práva\n- **Registrováno a regulováno v:** Estonská republika, Evropská unie',
    },
    {
      id: 'responsible',
      title: 'Osoba odpovědná za obsah',
      body:
        '**Andreas A. Gleim**\nJednatel / Osoba odpovědná za obsah podle estonského obchodního zákoníku (äriseadustik) a § 18 MStV (Německo)\n\nE-mail: [logixa.one/kontakt](/kontakt)',
    },
    {
      id: 'contact',
      title: 'Kontakt',
      body:
        'E-mail: [logixa.one/kontakt](/kontakt)\nWebové stránky: [https://logixa.one](https://logixa.one)\n\nDotazy ohledně platformy, partnerství, tisku a ochrany osobních údajů nám můžete zasílat na výše uvedenou e-mailovou adresu nebo prostřednictvím [kontaktního formuláře](/kontakt).',
    },
    {
      id: 'eu',
      title: 'Řešení sporů na úrovni EU',
      body:
        'Evropská komise poskytuje platformu pro řešení sporů online (OS):\n\n[https://ec.europa.eu/consumers/odr/](https://ec.europa.eu/consumers/odr/)\n\nNejsme ochotni ani povinni účastnit se řízení o řešení sporů před spotřebitelským smírčím orgánem.',
    },
    {
      id: 'liability',
      title: 'Odpovědnost za obsah',
      body:
        'Jako poskytovatel služeb odpovídáme podle § 7 odst. 1 TMG (Německo) a estonského zákona InfoTS za vlastní obsah na těchto stránkách v souladu s obecnými právními předpisy. Podle §§ 8 až 10 TMG však jako poskytovatel služeb nejsme povinni sledovat přenášené nebo uložené cizí informace.\n\nPovinnosti odstranit nebo zablokovat užívání informací podle obecných právních předpisů tím zůstávají nedotčeny. Odpovědnost v této souvislosti je však možná až od okamžiku, kdy se dozvíme o konkrétním porušení práva.',
    },
    {
      id: 'liability-links',
      title: 'Odpovědnost za odkazy',
      body:
        'Naše nabídka obsahuje odkazy na externí webové stránky třetích stran, na jejichž obsah nemáme žádný vliv. Proto za tento cizí obsah nemůžeme převzít žádnou záruku. Za obsah odkazovaných stránek je vždy odpovědný příslušný poskytovatel nebo provozovatel těchto stránek.',
    },
    {
      id: 'copyright',
      title: 'Autorské právo',
      body:
        'Obsah a díla vytvořená provozovateli stránek na těchto stránkách podléhají autorskému právu. Rozmnožování, zpracování, šíření a jakýkoli druh využití nad rámec autorského práva vyžadují písemný souhlas příslušného autora, resp. tvůrce.\n\nStahování a kopírování této stránky jsou povoleny pouze pro soukromé, nikoli komerční použití.',
    },
  ],
};
